<div class="mat-dialog-wrapper view-receipt-dialog">
  <div class="d-flex align-items-center justify-space-between mb-1">
    <h2 class="m-0" mat-dialog-title>Bank Feeds Start Date</h2>
      <button
          type="button"
          mat-button
          disableRipple
          mat-dialog-close
          >
          <mat-icon>close</mat-icon>
      </button>
    </div>
    <div class="mb-2 mt-1">
        <div class="form-field d-flex align-items-center justify-content-center gap-20">
            <p class="m-0">Bank Feeds Start Date</p>
            <mat-form-field appearance="fill" class="w-170">
              <input
                matInput
                [matDatepicker]="startDate"
                autocomplete="off"
                [(ngModel)]="bankFeedsStartDate"
              />
              <mat-datepicker-toggle
                matSuffix
                [for]="startDate"
              ></mat-datepicker-toggle>
              <mat-datepicker
                #startDate
              ></mat-datepicker>
            </mat-form-field>
          </div>
        <div>Bank Transactions starting from the date mentioned here will be fetched under the auto-sync service.</div>
    </div>
</div>
  
<mat-dialog-actions class="m-0">
    <div>
      <button
        class="action-button primary-button mr-1"
        type="button"
        mat-button
        disableRipple
        (click)="bankFeedsStartDateSave()"
      >
        Save
      </button>
      <button
        class="action-button secondary-button"
        type="button"
        mat-button
        disableRipple
        mat-dialog-close
      >
        Cancel
      </button>
    </div>
  </mat-dialog-actions>

  